import { feeds } from "../../apis/services";
import { FETCH_SEASON_PERFORMANCE } from "../../constants/seasonPerformance";


export const getPreviousSeasonPerformance = (params) => ({
  type: FETCH_SEASON_PERFORMANCE,
  payload: feeds.getSeasonPerformance(params),
});